import React, { useState, useEffect } from 'react';

const ResponsiveInput = ({ type = 'text', value, onChange, placeholder, className, field }) => {
  const [isMobile, setIsMobile] = useState(false);
  
  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(field, e.target.value)}
      placeholder={placeholder}
      className={`text-input ${className || ''} ${isMobile ? 'mobile-input' : ''}`}
    />
  );
};

export default ResponsiveInput; 